const routerKey = {
  HOME: 'home',
  HOTEL: 'hotel',
  AIR: 'air',
  CRUISE: 'cruise',
  MY_QUOTE: 'myquotes',
  SEARCH: 'search',
  HOTEL_ADVANCED: 'hotelAdvanced',
  AIR_ADVANCED: 'airAdvanced',
  CRUISE_ADVANCED: 'cruiseAdvanced',
  QUOTE_MANAGEMENT: 'quoteManagement',
  HOTELS: 'hotels',
  HOTEL_CONTRACT: 'hotel-contract',
  AIRS: 'airs',
  FLIGHTS: 'flights',
  ROLES: 'roles',
  PACKAGES: 'packages',
  PROMOS: 'promos',
  REPORTS: 'reports',
  VOUCHER: 'voucher',
  CURRENCY: 'currency',
  TERMS_AND_CONDITIONS: 'Term & Conditions',
  LOGS: 'Logs',
  RULES_HISTORY: 'rules-history',
  QUOTE_CONFIGURATION: 'quote-configuration',
  ADMIN_SETUP: 'admin-setup',
  SYNC_DATA: 'sync-data',
  GROUP_TYPE: 'groupType',
  EMPTY: 'empty',
  NOT_FOUND: 'notfound',
  LOGIN: 'login',
  ACCESS_DENIED: 'accessDenied',
  ERROR: 'error',
  CRUISE_MANAGEMENT: 'cruiseManagement',
  LANDING_PAGE: 'landingPage',
  MAINTENANCE_PAGE: 'maintenancePage',
  TOURS: 'tours',
  MULTI_TOURS: 'multi-tours',
  ERROR_PAGE: 'error-page'
};
export default routerKey;
